<p class="helppoint-title">{{data.title}}</p>

<entity-selector *ngIf="!data.external" [searchBeforeFocus]="true" [(ngModel)]="partnerId" (valuechangefunction)="propagatePartner()" placeholder="{{ 'UPDATEPARTNERDIALOG.PARTNERASSISTANT.TITLE' | translate}}"
    [entitySelector]="'Partner'" [fixedFilterKeys]="filter"></entity-selector>

<input-component class="col-x" [(ngModel)]="data.name"
    placeholder="{{'PARTNER.NAME.CAPTION' | translate}}"></input-component>
<input-component class="col-x" [(ngModel)]="data.nif"
    placeholder="{{'PARTNER.NIF.CAPTION' | translate}}"></input-component>
<input-component class="col-x" [(ngModel)]="data.contactName"
    placeholder="{{'PARTNER.REFERENCENAME.CAPTION' | translate}}"></input-component>
<input-component class="col-x" [(ngModel)]="data.contactPhone"
    placeholder="{{'PARTNER.PHONE.CAPTION' | translate}}"></input-component>

<shared-selector-addressmanualaddress-component [external]="data.external" class="col-x" selectorPlaceholder="UPDATEPARTNERDIALOG.ADDRESSASSISTANT.TITLE"
    (onChanged)="onChangedAddress($event)" [disableRegistered]="true" [disableManual]="true" [addressManualAddress]="address">
</shared-selector-addressmanualaddress-component>

<div *ngIf="data.manualAddress">
    <input-component class="col-x" [(ngModel)]="data.manualAddress.formattedAddress"
        placeholder="{{'ADDRESS.FORMATTEDADDRESS.CAPTION' | translate}}"></input-component>
    <input-component class="col-x" placeholder="{{'ADDRESS.ADDRESSLINE1.CAPTION' | translate}}"
        [(ngModel)]="data.manualAddress.addressLine1"></input-component>
    <input-component class="col-x" placeholder="{{'ADDRESS.ADDRESSLINE2.CAPTION' | translate}}"
        [(ngModel)]="data.manualAddress.addressLine2"></input-component>
    <input-component class="col-x" placeholder="{{'ADDRESS.CITY.CAPTION' | translate}}"
        [(ngModel)]="data.manualAddress.city"></input-component>
    <input-component class="col-x" placeholder="{{'ADDRESS.PROVINCE.CAPTION' | translate}}"
        [(ngModel)]="data.manualAddress.province"></input-component>
    <input-component class="col-x" placeholder="{{'ADDRESS.POSTALCODE.CAPTION' | translate}}"
        [(ngModel)]="data.manualAddress.postalCode"></input-component>
    <input-component class="col-x" placeholder="{{'ADDRESS.STATE.CAPTION' | translate}}"
        [(ngModel)]="data.manualAddress.state"></input-component>
    <input-component class="col-x" placeholder="{{'ADDRESS.COUNTRY.CAPTION' | translate}}"
        [(ngModel)]="data.manualAddress.country"></input-component>
</div>

<div align="end">
    <button mat-raised-button class="helppoint-button confirm" (click)="onConfirm()"
        color="primary">{{'MAINTENANCE.ACCEPT' | translate}}</button>
    <button mat-raised-button class="helppoint-button close" (click)="onClose()"
        color="link">{{'CANCEL.BUTTON' | translate}}</button>
</div>
<div class="dummy"></div>